import { TabList } from "@mui/lab"
import { styled } from "@mui/material/styles"

export const SbTabList = styled(TabList)(({theme}) => ({
	"&": {
		paddingTop: "16px",
	}
}))

SbTabList.defaultProps = {
	...SbTabList.defaultProps,
	variant: "fullWidth",
}
